module.exports = __webpack_public_path__ + "img/report.cace8e7f.png";